/** @format */

export const RATE_CONSTANTS: { [index: string]: number } = {
    RATE_SUBTYPE_INTERNET_B: 1,
    RATE_SUBTYPE_INTERNET_KB: 2,
    RATE_SUBTYPE_INTERNET_MB: 3,
    RATE_SUBTYPE_INTERNET_GB: 4,
    RATE_SUBTYPE_INTERNET_TB: 5,
    RATE_SUBTYPE_INTERNET_KiB: 6,
    RATE_SUBTYPE_INTERNET_MiB: 7,
    RATE_SUBTYPE_INTERNET_GiB: 8,
    RATE_SUBTYPE_INTERNET_TiB: 9,
    RATE_SUBTYPE_SEC: 10,
    RATE_SUBTYPE_MIN: 11,
    RATE_SUBTYPE_CALL: 12,
    RATE_SUBTYPE_USES_RATIO_AS_COUNT: 13,
    RATE_SUBTYPE_EVENT_COUNT_AS_SINGULAR: 14,
    RATE_SUBTYPE_INTERNET_UNDEFINED_6: 15, //Reserved for future
};

export const RATE_TRANSLATIONS: { [index: string]: string } = {
    RATE_SUBTYPE_INTERNET_B: 'pricelists:rate_subtype.RATE_SUBTYPE_INTERNET_B',
    RATE_SUBTYPE_INTERNET_KB: 'pricelists:rate_subtype.RATE_SUBTYPE_INTERNET_KB',
    RATE_SUBTYPE_INTERNET_MB: 'pricelists:rate_subtype.RATE_SUBTYPE_INTERNET_MB',
    RATE_SUBTYPE_INTERNET_GB: 'pricelists:rate_subtype.RATE_SUBTYPE_INTERNET_GB',
    RATE_SUBTYPE_INTERNET_TB: 'pricelists:rate_subtype.RATE_SUBTYPE_INTERNET_TB',
    RATE_SUBTYPE_INTERNET_KiB: 'pricelists:rate_subtype.RATE_SUBTYPE_INTERNET_KiB',
    RATE_SUBTYPE_INTERNET_MiB: 'pricelists:rate_subtype.RATE_SUBTYPE_INTERNET_MiB',
    RATE_SUBTYPE_INTERNET_GiB: 'pricelists:rate_subtype.RATE_SUBTYPE_INTERNET_GiB',
    RATE_SUBTYPE_INTERNET_TiB: 'pricelists:rate_subtype.RATE_SUBTYPE_INTERNET_TiB',
    RATE_SUBTYPE_SEC: 'pricelists:rate_subtype.RATE_SUBTYPE_SEC',
    RATE_SUBTYPE_MIN: 'pricelists:rate_subtype.RATE_SUBTYPE_MIN',
    RATE_SUBTYPE_CALL: 'pricelists:rate_subtype.RATE_SUBTYPE_CALL',
    RATE_SUBTYPE_USES_RATIO_AS_COUNT: 'pricelists:rate_subtype.RATE_SUBTYPE_USES_RATIO_AS_COUNT',
    RATE_SUBTYPE_EVENT_COUNT_AS_SINGULAR: 'pricelists:rate_subtype.RATE_SUBTYPE_EVENT_COUNT_AS_SINGULAR',
    RATE_SUBTYPE_INTERNET_UNDEFINED_5: 'pricelists:rate_subtype.RATE_SUBTYPE_INTERNET_UNDEFINED_5', //Reserved for future
    RATE_SUBTYPE_INTERNET_UNDEFINED_6: 'pricelists:rate_subtype.RATE_SUBTYPE_INTERNET_UNDEFINED_6', //Reserved for future
};

export class RateHelper {
    public static mapRateConstantsNoUndefined = (): Array<{ name: string; value: number }> => {
        const arr: Array<{ name: string; value: number }> = [];
        for (const [key, value] of Object.entries(RATE_CONSTANTS)) {
            if (!key.includes('UNDEFINED')) {
                arr.push({ name: RATE_TRANSLATIONS[key], value: value });
            }
        }

        return arr;
    };
}
